import React from 'react';
import PropTypes from 'prop-types';
import { LuLoaderCircle, LuTrash2 } from 'react-icons/lu';
import Modal from '../../../components/ui/Modal';
import Button from '../../../components/ui/Button';
import GlassIcon from '../../../components/ui/GlassIcon';
import { HelpNote } from '../../ProfilePage/components/ProfileUi';
import useCenterText from '../centerText';
import { RichText } from './centerBits';

/**
 * "Merkez Sil": asks before deleting; a center used in projects gets the note
 * that its SMO Lead report data is kept. `busy` while the delete runs.
 */
const DeleteCenterDialog = ({ center, busy, onConfirm, onCancel }) => {
  const { t, language, label, richText } = useCenterText();
  return (
    <Modal
      isOpen={Boolean(center)}
      onClose={() => !busy && onCancel()}
      size="md"
      title={label('delete.title')}
      closeLabel={t('common.close')}
      lang={language}
      icon={(
        <GlassIcon gradient="tw-from-rose-400 tw-to-rose-600 tw-shadow-rose-500/30" size="xs">
          <LuTrash2 aria-hidden="true" className="tw-h-[18px] tw-w-[18px]" />
        </GlassIcon>
      )}
      footer={(
        <>
          <Button variant="ghost" onClick={onCancel} disabled={busy}>{label('common.cancel')}</Button>
          <Button variant="danger" onClick={onConfirm} disabled={busy} className="max-sm:tw-flex-1">
            {busy
              ? <LuLoaderCircle aria-hidden="true" className="tw-h-4 tw-w-4 tw-animate-spin" />
              : <LuTrash2 aria-hidden="true" className="tw-h-4 tw-w-4" />}
            {label('delete.confirm')}
          </Button>
        </>
      )}
    >
      {center && (
        <div className="tw-space-y-4">
          <p className="tw-text-[15px] tw-leading-relaxed tw-text-slate-700 dark:tw-text-slate-200">
            <RichText segments={richText('delete.message', { name: center['Adı'] || '-' })} />
          </p>
          {center.isUsedInProjects && (
            <HelpNote>
              <strong className="tw-block tw-font-semibold">{label('delete.usedTitle')}</strong>
              {label('delete.usedText')}
            </HelpNote>
          )}
          <p className="tw-text-sm tw-font-medium tw-text-rose-600 dark:tw-text-rose-300">{label('delete.irreversible')}</p>
        </div>
      )}
    </Modal>
  );
};

DeleteCenterDialog.propTypes = {
  center: PropTypes.object,
  busy: PropTypes.bool,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default DeleteCenterDialog;
